// Typelizer digest b4b5d6519996ec125877cb7f2c887065
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /api/users/me */
  me: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/api/users/me', {}, options),
    method: 'get',
  }),
}
